import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { Module } from '@library/store/modules/modules.interface';
import { Room } from '@library/store/rooms/rooms.interface';
import { RoomsAssets } from '@library/utils/constants/rooms';
import { SideBarCardExpandAnimation } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/components/sidebar-card/sidebar-card.component';
import { RoomTemperatureService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/room-temperature/room-temperature.service';
import { BoilerIconService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/room-temperature/set-point-card/boiler-icon/boiler-icon.service';
import { SidebarRoomService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/sidebar-room.service';
import { combineLatest } from 'rxjs';
import { SidebarCardExpandComponent } from '../../components/sidebar-card/sidebar-card-expand/sidebar-card-expand.component';

@Component({
  selector: 'app-sidebar-room-card',
  templateUrl: './sidebar-room-card.component.html',
  styleUrls: ['./sidebar-room-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    SidebarRoomService,
    RoomTemperatureService,
    BoilerIconService,
  ],
  animations: [SideBarCardExpandAnimation],
})
export class SidebarRoomCardComponent {

  @Input() room?: Room;

  RoomsAssets = RoomsAssets;
  EnumMeasureTypes = EnumMeasureTypes;

  roomModules$ = this.sidebarRoomService.roomModules$;

  viewModel$ = combineLatest({
    room: this.sidebarRoomService.room$,
    displayTemperature: this.roomTemperatureService.display$,
    temperatureModule: this.roomTemperatureService.module$,
    temperatureUnreachable: this.roomTemperatureService.unreachable$,
  });

  constructor(
    private sidebarRoomService: SidebarRoomService,
    private roomTemperatureService: RoomTemperatureService,
  ) { }

  ngOnInit() {
    this.sidebarRoomService.roomId$.next(this.room.id);
  }

  // This is used to open the sidebar card when the user clicks on all the card (not only the expand button)
  toggle(sidebarCardExpand: SidebarCardExpandComponent) {
    sidebarCardExpand.toggle();
  }

  getTemperatureDisplay(module: Module, room: Room) {
    return this.roomTemperatureService.getTemperatureDisplay(module, room);
  }
}
